import React from 'react';
import { DietFreemiumAccess, useTranslator } from '@front-activerse/common-components';

interface IDietFreemiumTag {
  access?: DietFreemiumAccess;
}

/**
 * Freemium availability badge shown between a diet's image and its title.
 *
 * Renders nothing when the backend says nothing about the diet — a config entry
 * the API does not know about looks exactly as it did before freemium existed.
 */
export const DietFreemiumTag: React.FC<IDietFreemiumTag> = ({ access }) => {
  const { t } = useTranslator();

  if (!access) {
    return null;
  }

  if (!access.isAvailable) {
    return (
      <span className="diet-freemium-tag paid" data-testid="diet-freemium-tag">
        {t('nutritionSettings.paid.label')}
      </span>
    );
  }

  // a non-positive freeDays would render "0 days free", which reads as a denial
  // while isAvailable says otherwise — treat it as plain availability
  if (access.freeDays && access.freeDays > 0) {
    return (
      <span className="diet-freemium-tag free" data-testid="diet-freemium-tag">
        {t('nutritionSettings.partFree.label', { count: access.freeDays })}
      </span>
    );
  }

  return (
    <span className="diet-freemium-tag free" data-testid="diet-freemium-tag">
      {t('nutritionSettings.free.label')}
    </span>
  );
};

export default DietFreemiumTag;
